'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = 'M240-16l0 400-240 0 64 128 384 0 64-128-224 0 0-48 192 0-240-352zM192 336l0-240-160 240 160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;